
export default function NotFoundPage() {
    window.location.assign('/');
    return null;
}